import { render, staticRenderFns } from "./SetCustomReminderModal.vue?vue&type=template&id=fbaf6494&scoped=true"
import script from "./SetCustomReminderModal.vue?vue&type=script&lang=ts"
export * from "./SetCustomReminderModal.vue?vue&type=script&lang=ts"
import style0 from "./SetCustomReminderModal.vue?vue&type=style&index=0&id=fbaf6494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaf6494",
  null
  
)

export default component.exports